// Hotfix user sidebar · Discovery + AI RAG reintegration · V12 Achromatic Strict.
// -----------------------------------------------------------------------------
// Chiude il gap tra pagine orfane (3 Discovery multi-social + AI RAG) e la
// sidebar V12 MINIMAL (10 cluster post-FASE C). Pattern coerente con hotfix
// admin precedente (v12_admin_nav_hotfix_full_coverage_extensions.js):
//
//  - `newGroups`: nuovi cluster da inserire dopo l'anchor specificato.
//  - `groupPatches`: append items a cluster esistenti (append-only, zero-touch).
//  - `applyUserDiscoveryExtensions(baseGroups)`: merge pure function usata
//    da `v12_user_nav.js` per esporre `V12_USER_NAV_MINIMAL` arricchito.
//
// Permissions: tutti i cluster/items `allowFor: ["user", "admin", "super_admin"]`.
// Target coverage · +1 cluster "Discovery" (3 items) + 1 item AI RAG nel cluster "ai".
// Totale route reintegrate: 4 (Lead/Content/Social Discovery + AI RAG).

const _USER_ROLES = ["user", "admin", "super_admin"];

export const V12_USER_NAV_DISCOVERY_EXTENSIONS = {
    // Append items dentro cluster esistenti (zero-touch).
    groupPatches: {
        ai: {
            append: [
                {
                    id: "min-ai-rag",
                    label: "AI RAG",
                    to: "/app/ai/rag",
                    implemented: true,
                    icon: "Database",
                    keywords: ["rag", "vector", "knowledge", "documents", "ai", "retrieval"],
                },
            ],
        },
    },
    // Nuovi cluster da inserire dopo l'anchor.
    newGroups: [
        {
            insertAfter: "lead",
            group: {
                id: "discovery",
                label: "Discovery",
                labelKey: "nav.cluster.discovery",
                icon: "Compass",
                allowFor: _USER_ROLES,
                items: [
                    {
                        id: "min-leads-discovery",
                        label: "Lead Discovery (B2B)",
                        to: "/app/leads/discovery",
                        implemented: true,
                        icon: "Target",
                        keywords: ["google", "reddit", "linkedin", "b2b", "serper", "discovery"],
                    },
                    {
                        id: "min-content-discovery",
                        label: "Content Discovery",
                        to: "/app/content/discovery",
                        implemented: true,
                        icon: "FileText",
                        keywords: ["youtube", "medium", "substack", "content", "discovery"],
                    },
                    {
                        id: "min-social-discovery",
                        label: "Social Discovery (B2C)",
                        to: "/app/social/discovery",
                        implemented: true,
                        icon: "Users",
                        keywords: ["twitter", "x", "facebook", "instagram", "tiktok", "quora", "b2c", "discovery"],
                    },
                ],
            },
        },
    ],
};

/**
 * Merge V12 user nav MINIMAL + Discovery extensions · pure function.
 * - Applica `groupPatches.{id}.append` ai cluster esistenti.
 * - Inserisce `newGroups` dopo l'`insertAfter` anchor.
 * - Pending residui (anchor mancante) → append in coda con warning.
 *
 * @param {Array} baseGroups - cluster V12_USER_NAV_MINIMAL base.
 * @returns {Array} cluster arricchiti · ordine deterministico.
 */
export function applyUserDiscoveryExtensions(baseGroups) {
    // 1. Append items in cluster esistenti.
    const groups = baseGroups.map((g) => {
        const patch = V12_USER_NAV_DISCOVERY_EXTENSIONS.groupPatches[g.id];
        if (patch?.append) {
            return { ...g, items: [...g.items, ...patch.append] };
        }
        return g;
    });

    // 2. Insert nuovi cluster dopo l'anchor.
    const out = [];
    const pending = [...V12_USER_NAV_DISCOVERY_EXTENSIONS.newGroups];
    for (const g of groups) {
        out.push(g);
        for (let i = pending.length - 1; i >= 0; i--) {
            if (pending[i].insertAfter === g.id) {
                out.push(pending[i].group);
                pending.splice(i, 1);
            }
        }
    }
    // Residui → append in coda.
    if (pending.length > 0) {
        // eslint-disable-next-line no-console
        console.warn(
            "[V12 user nav] discovery extensions con insertAfter non trovato:",
            pending.map((p) => p.group.id),
        );
        for (const p of pending) out.push(p.group);
    }
    return out;
}
